// BQB Fix - Corrige le problème de l'option par défaut
// Déclenche automatiquement l'option sélectionnée par défaut pour activer le BQB

(function() {
  'use strict';

  // Attendre que les scripts BQB soient initialisés
  function waitForBQBReady() {
    return new Promise((resolve) => {
      let attempts = 0;
      const maxAttempts = 30; // 3 secondes max
      
      const checkBQB = () => {
        attempts++;
        
        // Vérifier si les fonctions BQB sont disponibles
        const bqbFunctionsReady = typeof window.bqb_updateQuantity === 'function';
        
        // Vérifier si les éléments BQB sont présents
        const bqbElementsPresent = document.querySelectorAll('.bqb-ui').length > 0;
        
        if (bqbFunctionsReady && bqbElementsPresent) {
          console.log('BQB Fix: Scripts BQB prêts, déclenchement de l\'option par défaut...');
          resolve();
        } else if (attempts < maxAttempts) {
          setTimeout(checkBQB, 100);
        } else {
          console.log('BQB Fix: Scripts BQB non prêts après 3s, tentative quand même...');
          resolve();
        }
      };
      
      checkBQB();
    });
  }

  // Déclencher l'option sélectionnée par défaut
  function triggerDefaultBQBOption() {
    const bqbContainer = document.querySelector('.bqb-ui');
    if (bqbContainer) {
      // Trouver l'option radio sélectionnée par défaut
      const selectedRadio = bqbContainer.querySelector('input[type="radio"]:checked');
      if (selectedRadio) {
        // Simuler un clic pour déclencher le BQB
        selectedRadio.click();
        
        // Extraire la quantité de la valeur de l'option (ex: "3" depuis "3 boîtes")
        const optionValue = selectedRadio.value;
        const quantityMatch = optionValue.match(/(\d+)/);
        
        if (quantityMatch && window.bqb_updateQuantity) {
          const quantity = parseInt(quantityMatch[1]);
          console.log('BQB Fix: Mise à jour forcée de la quantité à', quantity);
          
          // Forcer la mise à jour de la quantité via l'API BQB
          window.bqb_updateQuantity(quantity);
          
          // Mettre à jour aussi tous les champs quantity du formulaire
          document.querySelectorAll('input[name="quantity"]').forEach(input => {
            input.value = quantity;
          });
          
          // Mettre à jour le champ principal
          const mainQuantityInput = document.getElementById('Quantity-buy_buttons');
          if (mainQuantityInput) {
            mainQuantityInput.value = quantity;
          }
        }
        
        console.log('BQB Fix: Option par défaut déclenchée:', selectedRadio.value);
        return true;
      } else {
        console.log('BQB Fix: Aucune option sélectionnée par défaut trouvée');
        return false;
      }
    } else {
      console.log('BQB Fix: Container BQB non trouvé');
      return false;
    }
  }

  // Initialiser le fix
  async function initBQBFix() {
    // Attendre que les scripts BQB soient prêts
    await waitForBQBReady();
    
    // Déclencher l'option par défaut avec un délai
    setTimeout(() => {
      const success = triggerDefaultBQBOption();
      if (!success) {
        // Si ça n'a pas marché, réessayer après un délai
        setTimeout(triggerDefaultBQBOption, 500);
      }
    }, 1000);
  }

  // Attendre que le DOM soit chargé
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBQBFix);
  } else {
    initBQBFix();
  }

  // Réessayer lors des changements de variante
  document.addEventListener('variant:change', () => {
    setTimeout(triggerDefaultBQBOption, 500);
  });

  // Réessayer lors des changements de page
  window.addEventListener('popstate', () => {
    setTimeout(initBQBFix, 300);
  });

  console.log('BQB Fix: Script de correction chargé');
})();